import {
  SortOrder,
  SourcingTenderEntrySortColumn,
  type SourcingTenderEntrySortInput,
} from "@/shared/gql/graphql";

export type EntrySort = SourcingTenderEntrySortInput;

export const DEFAULT_ENTRY_SORT: EntrySort = {
  column: SourcingTenderEntrySortColumn.CreatedAt,
  direction: SortOrder.Desc,
};

// The direction a column sorts in when it is first chosen: newest first for creation, least sure first for confidence.
const FIRST_DIRECTION: Record<SourcingTenderEntrySortColumn, SortOrder> = {
  [SourcingTenderEntrySortColumn.CreatedAt]: SortOrder.Desc,
  [SourcingTenderEntrySortColumn.ExpectedPublicationDate]: SortOrder.Asc,
  [SourcingTenderEntrySortColumn.LowestTagConfidence]: SortOrder.Asc,
};

const reverse = (direction: SortOrder) =>
  direction === SortOrder.Asc ? SortOrder.Desc : SortOrder.Asc;

/** Choosing the sorted column again flips its direction; another column starts at its own first direction. */
export const nextEntrySort = (
  current: EntrySort,
  column: SourcingTenderEntrySortColumn,
): EntrySort => ({
  column,
  direction:
    current.column === column
      ? reverse(current.direction)
      : FIRST_DIRECTION[column],
});

/** Least sure AI tag waiting for review first; entries without one come last. */
export const LOWEST_CONFIDENCE_FIRST: EntrySort = {
  column: SourcingTenderEntrySortColumn.LowestTagConfidence,
  direction: SortOrder.Asc,
};
